module.exports = __webpack_public_path__ + "static/media/twitter.a6ec21d0.svg";